// frontend/src/pages/LoginPage.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const LoginPage = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isInstructorMode, setIsInstructorMode] = useState(false);
  const [instructorEmail, setInstructorEmail] = useState('');
  const [instructorPassword, setInstructorPassword] = useState('');
  
  const { loginStudent, loginInstructor } = useAuth();
  const navigate = useNavigate();
  
  const handleStudentLogin = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!password) {
      setError('Please enter the shared password');
      return;
    }
    
    const success = await loginStudent(password);
    if (success) {
      navigate('/');
    } else {
      setError('Invalid password');
    }
  };
  
  const handleInstructorLogin = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!instructorEmail || !instructorPassword) {
      setError('Please enter both email and password');
      return;
    }
    
    const success = await loginInstructor({
      email: instructorEmail,
      password: instructorPassword
    });
    
    if (success) {
      navigate('/instructor');
    } else {
      setError('Invalid credentials');
    }
  };
  
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-8">
          {isInstructorMode ? 'Instructor Login' : 'Ask Me Anything'}
        </h2>
        
        {isInstructorMode ? (
          <form onSubmit={handleInstructorLogin} className="space-y-4">
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
                Email
              </label>
              <input
                id="email"
                type="email"
                value={instructorEmail}
                onChange={(e) => setInstructorEmail(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                placeholder="instructor@school.edu"
              />
            </div>
            
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">
                Password
              </label>
              <input
                id="password"
                type="password"
                value={instructorPassword}
                onChange={(e) => setInstructorPassword(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </div>
            
            {error && (
              <div className="text-red-500 text-sm">{error}</div>
            )}
            
            <button
              type="submit"
              className="w-full bg-indigo-600 text-white py-2 px-4 rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >
              Login as Instructor
            </button>
            
            <div className="text-center mt-4">
              <button
                type="button"
                onClick={() => setIsInstructorMode(false)}
                className="text-sm text-indigo-600 hover:text-indigo-800"
              >
                Student Login
              </button>
            </div>
          </form>
        ) : (
          <form onSubmit={handleStudentLogin} className="space-y-4">
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="shared-password">
                Shared Password
              </label>
              <input
                id="shared-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                placeholder="Enter the classroom password"
              />
            </div>
            
            {error && (
              <div className="text-red-500 text-sm">{error}</div>
            )}
            
            <button
              type="submit"
              className="w-full bg-indigo-600 text-white py-2 px-4 rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >
              Enter
            </button>
            
            <div className="text-center mt-4">
              <button
                type="button"
                onClick={() => setIsInstructorMode(true)}
                className="text-sm text-indigo-600 hover:text-indigo-800"
              >
                Instructor Login
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default LoginPage;